module.exports = __webpack_public_path__ + "static/media/TD.d25a79f0.svg";